/**
 * Main entry point for theme scripts
 *
 * Initializes all utility functions and sets up event listeners.
 *
 * IMPORTANT: Import order matters!
 * - smooth-scroll must be first (initializes ScrollSmoother before ScrollTrigger)
 * - horizontal-scroll before body-background-color (for proper scroll depth calculation)
 */

// Utils - custom cursor (self-initializing)
import './utils/body';
import './utils/business-hours';
import './utils/custom-cursor';
import './utils/scroll-animations';
import './utils/site-logo';
import './utils/parallax';
import './utils/horizontal-scroll';
import './utils/body-background-color';
import './utils/text-background';
import './utils/forms';
import './utils/pre-cta-detector';

// Blocks - creates DOM elements (hamburger, etc.)
import './blocks/button';
import './blocks/navigation';
import './blocks/paragraph';

// Components - initialize behaviors (must come after blocks that create elements)
import './components/magnetic';
import './components/player-ratings';
